import React, { FormEvent, useState } from 'react';
import { useHistory } from 'react-router';
import { ROOT_API_URL, PATH_PREFIX } from '../../core/config/config';
import GlobalLoader from '../GlobalLoader/GlobalLoader';
import './Login.scss';

export default function Login(): JSX.Element {
  const apiUrl = ROOT_API_URL;
  const [pending, setPending] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const history = useHistory();

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();

    try {
      setPending(true);
      const res = await fetch(`${apiUrl}/token`, {
        method: 'POST',
        body: JSON.stringify({ login: username, password }),
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const data = await res.json();

      setPending(false);

      if (data) {
        window.sessionStorage.setItem('token', data.token);
        window.sessionStorage.setItem('isAdmin', data.isAdmin);

        if (data.isAdmin) {
          history.push(`${PATH_PREFIX}/admin`);
        }
      }
    } catch (err) {
      setPending(false);
      // eslint-disable-next-line no-console
      console.error(err);
    }

    return false;
  }

  return (
    <div className="Login">
      {pending ? <GlobalLoader /> : null}
      <form
        onSubmit={(e) => {
          handleSubmit(e);
        }}
      >
        <div className="form-group">
          <label htmlFor="username">
            Login:
            <input
              id="username"
              className="form-control"
              autoComplete="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </label>
        </div>
        <div className="form-group">
          <label htmlFor="password">
            Password:
            <input
              id="password"
              className="form-control"
              autoComplete="current-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </label>
        </div>
        <input type="submit" className="btn btn-primary btn-lg" value="Submit" />
      </form>
    </div>
  );
}
